import { AdditionalAppLogInfo, LogLevel } from 'shared/types/logger';
import { sharedLog } from 'shared/logger/sharedLog';
import { appSumoLogicLogger } from './appSumoLogicLogger';
import { appSentryLog } from './initSentryInApp';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';

export const appLog = (
  msg: string,
  level: LogLevel,
  additionalInfo: AdditionalAppLogInfo,
  full_error_object?: any
): void => {
  sharedLog({
    user_id: LocalStorageManager.getUserIdSilent(),
    user_email: LocalStorageManager.getUserEmailSilent(),
    msg,
    level,
    additionalInfo,
    full_error_object,
    loggers: [appSumoLogicLogger, { log: appSentryLog }],
  });
};
